import React from "react";

import { IconButton, IconButtonProps } from "@chakra-ui/react";

import { CloseIcon } from "icons";

const CloseButton = ({
  boxSize,
  ...props
}: Partial<IconButtonProps>): React.ReactElement => (
  <IconButton
    icon={<CloseIcon boxSize={boxSize} />}
    aria-label="Close"
    variant="link"
    colorScheme="black"
    {...props}
  />
);

export default CloseButton;
